import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { ALL_LANGUAGES, LANGUAGE_EN_GB, LANGUAGE_EN } from '~/utils/constants';
import { getCountry } from '~/utils/cookie';
import { getLanguage, setLanguage, mapToUiLanguage } from '~/utils/language';
Vue.use(VueI18n);
var DEFAULT_LANGUAGE = LANGUAGE_EN_GB;
export default (function (_ref, inject) {
  var _getCountry;
  var app = _ref.app,
    query = _ref.query;
  // Detect browser language and use that as language if matches
  var browserLanguage = ALL_LANGUAGES.find(function (lang) {
    if (lang === navigator.language) {
      return true;
    }
    var browserPrimary = navigator.language.split('-')[0];
    // Map any English variant to en-GB
    if (browserPrimary === 'en') {
      return lang === 'en-GB';
    }
    // Match other languages by primary subtag
    return lang === browserPrimary;
  });
  var queryLanguageParam = mapToUiLanguage(query.language);
  var queryLanguage = ALL_LANGUAGES.find(function (language) {
    return language === queryLanguageParam;
  });
  var cookieLanguageParts = (_getCountry = getCountry('')) === null || _getCountry === void 0 ? void 0 : _getCountry.split('-');
  var cookieLanguage = ALL_LANGUAGES.find(function (language) {
    var _cookieLanguageParts$;
    if (cookieLanguageParts !== null && cookieLanguageParts !== void 0 && (_cookieLanguageParts$ = cookieLanguageParts[0]) !== null && _cookieLanguageParts$ !== void 0 && _cookieLanguageParts$.startsWith(LANGUAGE_EN)) {
      return language === LANGUAGE_EN_GB;
    }
    return language === (cookieLanguageParts === null || cookieLanguageParts === void 0 ? void 0 : cookieLanguageParts[0]);
  });

  // Load default locale from localStorage
  var language = getLanguage(queryLanguage || cookieLanguage || browserLanguage || DEFAULT_LANGUAGE);

  // Set i18n instance on app. This way we can use
  // it in middleware and pages asyncData/fetch
  var i18n = new VueI18n({
    locale: language,
    fallbackLocale: LANGUAGE_EN_GB,
    dateTimeFormats: {
      en: {
        time: {
          hour: 'numeric',
          minute: 'numeric',
          hour12: false
        },
        short: {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric'
        },
        long: {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false
        }
      },
      'en-GB': {
        time: {
          hour: 'numeric',
          minute: 'numeric',
          hour12: false
        },
        short: {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric'
        },
        long: {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false
        }
      },
      fi: {
        time: {
          hour: 'numeric',
          minute: 'numeric',
          hour12: false
        },
        short: {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric'
        },
        long: {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false
        }
      },
      de: {
        time: {
          hour: 'numeric',
          minute: 'numeric',
          hour12: false
        },
        short: {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric'
        },
        long: {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false
        }
      },
      sv: {
        time: {
          hour: 'numeric',
          minute: 'numeric',
          hour12: false
        },
        short: {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric'
        },
        long: {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false
        }
      },
      pl: {
        time: {
          hour: 'numeric',
          minute: 'numeric',
          hour12: false
        },
        short: {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric'
        },
        long: {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false
        }
      }
    },
    // TODO: we should get rid of this configuration and use i18n-n component instead as in SubscribeModalPlanCard
    numberFormats: {
      en: {
        currency: {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2
        }
      },
      'fi-PL': {
        currency: {
          style: 'currency',
          currency: 'PLN',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'PLN',
          minimumFractionDigits: 2
        }
      },
      'en-PL': {
        currency: {
          style: 'currency',
          currency: 'PLN',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'PLN',
          minimumFractionDigits: 2
        }
      },
      'sv-PL': {
        currency: {
          style: 'currency',
          currency: 'PLN',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'PLN',
          minimumFractionDigits: 2
        }
      },
      'de-PL': {
        currency: {
          style: 'currency',
          currency: 'PLN',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'PLN',
          minimumFractionDigits: 2
        }
      },
      'fi-FI': {
        currency: {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2
        }
      },
      'en-FI': {
        currency: {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2
        }
      },
      'sv-FI': {
        currency: {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2
        }
      },
      'de-FI': {
        currency: {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2
        }
      },
      'fi-SE': {
        currency: {
          style: 'currency',
          currency: 'SEK',
          currencyDisplay: 'symbol',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'SEK',
          minimumFractionDigits: 2
        }
      },
      'en-SE': {
        currency: {
          style: 'currency',
          currency: 'SEK',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'SEK',
          minimumFractionDigits: 2
        }
      },
      'sv-SE': {
        currency: {
          style: 'currency',
          currency: 'SEK',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'SEK',
          minimumFractionDigits: 2
        }
      },
      'de-SE': {
        currency: {
          style: 'currency',
          currency: 'SEK',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'SEK',
          minimumFractionDigits: 2
        }
      },
      'fi-GB': {
        currency: {
          style: 'currency',
          currency: 'GBP',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'GBP',
          minimumFractionDigits: 2
        }
      },
      'en-GB': {
        currency: {
          style: 'currency',
          currency: 'GBP',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'GBP',
          minimumFractionDigits: 2
        }
      },
      'sv-GB': {
        currency: {
          style: 'currency',
          currency: 'GBP',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'GBP',
          minimumFractionDigits: 2
        }
      },
      'de-GB': {
        currency: {
          style: 'currency',
          currency: 'GBP',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'GBP',
          minimumFractionDigits: 2
        }
      },
      'fi-DE': {
        currency: {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2
        }
      },
      'en-DE': {
        currency: {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2
        }
      },
      'sv-DE': {
        currency: {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2
        }
      },
      'de-DE': {
        currency: {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2
        }
      },
      'pl-PL': {
        currency: {
          style: 'currency',
          currency: 'PLN',
          minimumFractionDigits: 0
        },
        currencyLong: {
          style: 'currency',
          currency: 'PLN',
          minimumFractionDigits: 2
        }
      }
    },
    messages: {
      fi: {
        common: require('~/locales/fi/common.json'),
        p: require('~/locales/fi/pages.json'),
        c: require('~/locales/fi/components.json')
      },
      'en-GB': {
        common: require('~/locales/en_GB/common.json'),
        p: require('~/locales/en_GB/pages.json'),
        c: require('~/locales/en_GB/components.json')
      },
      sv: {
        common: require('~/locales/sv/common.json'),
        c: require('~/locales/sv/components.json'),
        p: require('~/locales/sv/pages.json')
      },
      de: {
        common: require('~/locales/de/common.json'),
        c: require('~/locales/de/components.json'),
        p: require('~/locales/de/pages.json')
      },
      pl: {
        common: require('~/locales/pl/common.json'),
        c: require('~/locales/pl/components.json'),
        p: require('~/locales/pl/pages.json')
      }
    }
  });
  app.i18n = i18n;

  // Listen for store changes and update i18n language
  // and persist the language to the localStorage
  app.store.watch(function (state) {
    return state.language;
  }, function (l) {
    setLanguage(l);
    i18n.locale = l;
  });

  // Set initial locale
  app.store.dispatch('setLanguage', language);
});